import { render, staticRenderFns } from "./CampingItem.vue?vue&type=template&id=14f0679e&scoped=true"
import script from "./CampingItem.vue?vue&type=script&lang=js"
export * from "./CampingItem.vue?vue&type=script&lang=js"
import style0 from "./CampingItem.vue?vue&type=style&index=0&id=14f0679e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f0679e",
  null
  
)

export default component.exports